<template>
	<div v-if="predefinedAvatars.length" class="avatar-builder-cnt">
		<ja-header :title="title" :subtitle="subtitle">
			<template v-slot:icon>
				<svgicon name="headerIcons/profile"></svgicon>
			</template>
		</ja-header>
		<content>
			<div class="controls">
				<div class="controls-cnt">
					<ja-avatar-builder-control :label="$t('avatarsPresetLabel')">
						<ja-avatar-picker
							v-model="selectedPreset"
							:paginated="false"
							:data="predefinedAvatars"
						></ja-avatar-picker>
					</ja-avatar-builder-control>
				</div>
			</div>
			<div class="preview">
				<div class="preview-avatar">
					<ja-avatar-preview
						ref="avatar-preview"
						:preset="selectedPreset"
					></ja-avatar-preview>
				</div>
				<h1 class="body-text-2">
					{{ $t('avatarsInfo') }}
				</h1>
				<div class="button-wrapper">
					<ja-button
						class="large"
						name="avatar-next"
						:disabled="!selectedPreset"
						:aria-label="$t('goToQuestionnaire')"
						@click.native.once="saveAvatar"
						>{{ $t('next') }}</ja-button
					>
				</div>
			</div>
		</content>
	</div>
</template>
<script>
import '../components/icons/headerIcons/profile';
import UserData from '../mixins/UserData';
import AvatarsService from '@/services/AvatarsService';
import Header from '../components/ui/headers/Header';
import Button from '../components/ui/Button';
import AvatarPreview from '../components/AvatarPreview/AvatarPreview';
import AvatarBuilderControl from '../components/AvatarBuilderControls/AvatarBuilderControl';
import AvatarPicker from '../components/AvatarBuilderControls/AvatarPicker';
import NavigationLoading from '../mixins/NavigationLoading';

export default {
	components: {
		jaHeader: Header,
		jaButton: Button,
		jaAvatarBuilderControl: AvatarBuilderControl,
		jaAvatarPreview: AvatarPreview,
		jaAvatarPicker: AvatarPicker
	},
	mixins: [UserData, NavigationLoading],
	data() {
		return {
			title: this.$t('avatarsTitle'),
			subtitle: this.$t('avatarsSubtitle'),
			predefinedAvatars: [],
			selectedPreset: null
		};
	},
	computed: {
		isFirstSection() {
			return this.selectedOption == 'predefined';
		}
	},
	created() {
		AvatarsService.getAll().then(avatars => {
			this.predefinedAvatars = avatars;
			this.$store.commit('setLoading', false);
		});

		if (this.userData) {
			this.$store.dispatch('getPauseState');
		}
	},
	methods: {
		saveAvatar() {
			AvatarsService.updateUserAvatar(
				this.userData.studentId,
				this.selectedPreset.id
			).then(() => {
				this.$store.commit('setLoading', true);
				this.$store.commit(
					'setAvatarImg',
					this.selectedPreset.largeImageBase64
				);
				this.$router.push({ name: 'informationStudent' });
			});
		}
	}
};
</script>
<style lang="scss" scoped>
.avatar-builder-cnt {
	height: 100%;
	max-height: 100%;
	display: flex;
	flex-direction: column;
	content {
		max-height: calc(100vh - 100px);
		height: calc(100vh - 100px);
		display: flex;
		flex-direction: row-reverse;

		.preview {
			display: flex;
			flex-grow: 1;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			padding: 32px 5%;
			background-color: $page-bgcolor;

			@media (min-width: $breakpoint-mid) {
				padding: 64px 5%;
			}

			.preview-avatar {
				width: 50%;
			}

			h1 {
				margin-top: 32px;
				margin-bottom: 0;
				color: $font-gray;
			}

			.button-wrapper {
				padding-top: 32px;
			}
		}

		.controls {
			flex-shrink: 0;
			padding: 32px 5%;
			background-color: $container-bgcolor;
			height: 100%;
			overflow-y: auto;

			.segmented-control {
				width: 100%;
				.segment {
					width: 50%;
				}
			}
		}
	}
}
</style>
